import React, { useContext, useState } from 'react';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import ProductImage from '../product/ProductImage';
import classNames from 'classnames';
import Icon from '@stone/ui/icon/Icon';
import ProductLink from '../common/ProductLink';
import ProductTilesListContext from '@stone/scripts/contexts/ProductTilesListContext';
import Image from '@stone/ui/image/Image';
const LatestCarouselTile = (props) => {
    const { isTouch } = useMediaQueries();
    const analyticsContext = useContext(ProductTilesListContext);
    const { product, editorialProduct } = props;
    const [isOpen, setIsOpen] = useState();
    const uuid = `slide-${props.parentUuid}_${props.position}`;
    const renderInfo = (product) => (React.createElement("div", { className: "tile--content" },
        React.createElement("div", { className: classNames('tile--content_details', { 'is-open': isOpen }) },
            React.createElement(Icon, { family: '10', name: isOpen ? 'minimize' : 'open' }),
            React.createElement("div", { className: "tile--content_details-content", id: uuid },
                React.createElement("h3", { "aria-hidden": true, className: "font__title" }, product === null || product === void 0 ? void 0 : product.productName),
                React.createElement("p", { "aria-hidden": true, className: "mt-32 pt-4" }, product === null || product === void 0 ? void 0 : product.shortDescription)))));
    const renderProduct = () => {
        var _a;
        return (React.createElement(ProductLink, { className: "latest_carousel--tile", ariaLabelledby: uuid, product: product, onFocus: () => {
                setIsOpen(true);
                props.onFocus && props.onFocus();
            }, onBlur: () => {
                setIsOpen(false);
            }, onMouseEnter: () => {
                setIsOpen(true);
            }, onMouseLeave: () => {
                setIsOpen(false);
            }, ariaHidden: props.focusDisabled, tabIndex: props.focusDisabled ? -1 : null, analyticsData: analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.analyticsData },
            React.createElement(ProductImage, { type: (_a = product.assetOverride) === null || _a === void 0 ? void 0 : _a.carlatest, ariaHidden: true, img: product.imgs }),
            !isTouch && renderInfo(product)));
    };
    const renderEditorialProduct = () => {
        var _a;
        return (React.createElement("div", { className: "latest_carousel--tile", onFocus: () => {
                setIsOpen(true);
                props.onFocus && props.onFocus();
            }, onBlur: () => {
                setIsOpen(false);
            }, onMouseEnter: () => {
                setIsOpen(true);
            }, onMouseLeave: () => {
                setIsOpen(false);
            }, "aria-hidden": props.focusDisabled, tabIndex: props.focusDisabled ? -1 : null },
            React.createElement(Image, { src: (_a = editorialProduct === null || editorialProduct === void 0 ? void 0 : editorialProduct.custom) === null || _a === void 0 ? void 0 : _a.image, ariaHidden: true, alt: "" }),
            !isTouch && renderInfo(editorialProduct)));
    };
    if (!product && !editorialProduct)
        return null;
    return (React.createElement(React.Fragment, null,
        !!product && renderProduct(),
        !!editorialProduct && renderEditorialProduct()));
};
export default LatestCarouselTile;
